import React from 'react';
import { STEPS } from '../../utils/constants';
import { useStateContext } from '../../context/StateContext';
import style from './banner.module.scss';

const Banner = () => {
	const { state: { pageSettings: { bannerSettings, useFastPay } = {}, isMobile, currentStep }, } = useStateContext();
	const showBanner = !isMobile && bannerSettings?.bannerUrl && (useFastPay || (!useFastPay && currentStep === STEPS.PAYMENT));

	if (!showBanner) {
		return '';
	}

	return <img className={style.banner} alt='banner' src={bannerSettings?.bannerUrl}/>;
};

export default Banner;
